(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-tabs"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function(){ 
	if(document.querySelectorAll('.tabs').length) {
		PwnTabs.init()
	}
})

var PwnTabs = {
  	data: {},

  	init: function() {
		this.data.tabsSections = document.querySelectorAll(".tab")
		this.data.tabsMenu = document.querySelectorAll(".tabs__link")

		this.bindUIActions()

		this.data.tabsMenu.forEach((tabMenuItem, i) => {
			if(!tabMenuItem.classList.contains("tabs__link--external")) {
				if(window.location.hash == tabMenuItem.hash) {
					$('html, body').animate({
						scrollTop: $($.attr(tabMenuItem, 'href')).offset().top - 60
					}, 300)
				}
			}
		})
  	},

  	bindUIActions: function() {
    	this.data.tabsMenu.forEach((tabMenuItem, i) => {
      		if(!tabMenuItem.classList.contains("tabs__link--external")) {
        		tabMenuItem.addEventListener("click", (event) => {
          			let urlParams = new URLSearchParams(window.location.search)
          			window.history.replaceState('', '', window.location.pathname + (urlParams.toString().length > 0 ? "?" + urlParams.toString() : "") + tabMenuItem.hash);
          			event.preventDefault()
        		})
     		}
    	})

		window.addEventListener('scroll', (event) => {
			this.data.tabsSections.forEach((tabSection) => {
            	var rect = tabSection.getBoundingClientRect()
            	if(rect.top < window.innerHeight / 3) {
					
					this.tabMenuItemHightlight(tabSection.id)
					return
				}
			})
		})
  	},

	tabMenuItemHightlight: function(tabId) {
		this.data.tabsMenu.forEach((tabMenuItem) => {
			if(tabMenuItem.getAttribute('href') == '#' + tabId) {
				tabMenuItem.classList.add('tabs__link--selected')
			}
			else {
				tabMenuItem.classList.remove('tabs__link--selected')
			}
		})
	}
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-cards"]) return;
  try {
    

class CardsGrid {
    constructor(rootEl) {
        this.rootEl = rootEl
        this.isScrollable = (typeof this.rootEl.dataset.isScrollable !== "undefined")
        this.sliderEl = this.rootEl.querySelector('.swiper')
        this.cards = this.rootEl.querySelectorAll('.card')
        
        this.filter = this.rootEl.querySelector('.products_list__filters')
        if(this.filter) {
            this.filters = new CardsGridFilters({
                rootEl: this.rootEl.querySelector('.products_list__filters'),
                parent: this
            })
        }

        this.toggles = [...this.cards].map(el => new CardToggle(el))

        if(this.isScrollable) {
            this.swiper = this.initSlider()
        }
        this.bindUIActions()
    }

    bindUIActions() {}

    applyFilter(tags) { 
        if(tags === '') {
            this.cards.forEach(card => card.classList.remove('hide'))
            if(this.swiper) this.swiper.update()
            return
        }
        const tagsArr = tags.split(',')
        this.cards.forEach(card => {
            let shouldShow = false
            card.dataset.tags.split(',').forEach(ct => {
                shouldShow = shouldShow || tagsArr.includes(ct)
            })
            if(shouldShow == true) card.classList.remove('hide')
            else card.classList.add('hide')
        })
        if(this.swiper) this.swiper.update()
    }

    showCard(card) {}
    hideCard(card) {}

    initSlider() {
        return new Swiper(this.sliderEl,  {
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 16,
            freeMode: {
                enabled: false,
                momentumRatio: 0.1,
            },
            pagination: {
                el: ".swiper-pagination",
                dynamicBullets: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: "auto",
                    freeMode: {
                        enabled: true,
                        momentumRatio: 0.1,
                    },
                    centeredSlides: false,
                    spaceBetween: 30,
                    observer: true,
                    observeSlideChildren: true,
                }
            }
        })
    }
}

class CardToggle {
    constructor(rootEl) {
        this.rootEl = rootEl // card
        
        this.toggle = this.rootEl.querySelector('.card__toggle')
        if(!this.toggle) return

        this.toggleOptions = this.toggle.querySelectorAll('.card__toggle_item')
        this.imageGrids = this.rootEl.querySelectorAll('.card__image_grid')

        this.bindUIActions()
    }

    bindUIActions() {
        this.toggleOptions.forEach(option => {
            option.addEventListener('click', () => {
                this.setSelected(option.dataset.index)
            })
        })
    }

    setSelected(selectedIndex) {
        this.toggleOptions.forEach((option, index) => {
            this.imageGrids[index].style.transform = `translate3d(${ (index - selectedIndex) * 100 }%,0 ,0)`
            if(index == selectedIndex) {
                option.classList.add('is_selected')
            }
            else {
                option.classList.remove('is_selected')
            }
        })
    }
}

class CardsGridFilters {
    constructor({rootEl, parent}) {
        this.rootEl = rootEl
        this.options = this.rootEl.querySelectorAll('.products_list__filter')
        this.parent = parent

        this.bindUIActions()
    }

    bindUIActions() {
        this.options.forEach(option => {
            option.addEventListener('click', e => {
                this.setSelected(option)
            })
        })
    }

    setSelected(el) {
        this.options.forEach(option => {
            if(el == option) {
                option.classList.add('is_selected')
                this.parent.applyFilter(option.dataset.tags)
            }
            else {
                option.classList.remove('is_selected')
            }
        })
        
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const cardsLists = [...document.querySelectorAll('.products_list')].map(el => new CardsGrid(el))
})  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-main-menu"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var headerEl = document.querySelector('.main-header__bar');
    var menuDrawerButtonEl = document.getElementById('drawer-open');
    var menuDrawerEl = document.getElementById('nav-drawer');

    menuDrawerButtonEl.addEventListener('click', (event) => {
      menuDrawerEl.classList.toggle('show');
    });

    window.addEventListener('click', (event) => {
      if (!headerEl.contains(event.target)) {
        menuDrawerEl.classList.remove('show');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-tabs"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function(){ 
	if(document.querySelectorAll('.tabs').length) {
		PwnTabs.init()
	}
})

var PwnTabs = {
  	data: {},

  	init: function() {
		this.data.tabsSections = document.querySelectorAll(".tab")
		this.data.tabsMenu = document.querySelectorAll(".tabs__link")

		this.bindUIActions()

		// this.data.tabsMenu.forEach((tabMenuItem, i) => {
		// 	if(!tabMenuItem.classList.contains("tabs__link--external")) {
		// 		if(window.location.hash == tabMenuItem.hash) {
		// 			$('html, body').animate({
		// 				scrollTop: $($.attr(tabMenuItem, 'href')).offset().top - 60
		// 			}, 300)
		// 		}
		// 	}
		// })
  	},

  	bindUIActions: function() {
    	this.data.tabsMenu.forEach((tabMenuItem, i) => {
      		if(!tabMenuItem.classList.contains("tabs__link--external")) {
        		tabMenuItem.addEventListener("click", (event) => {
          			let urlParams = new URLSearchParams(window.location.search)
          			window.history.replaceState('', '', window.location.pathname + (urlParams.toString().length > 0 ? "?" + urlParams.toString() : "") + tabMenuItem.hash);
          			event.preventDefault()
        		})
     		}
    	})

		window.addEventListener('scroll', (event) => {
			this.data.tabsSections.forEach((tabSection) => {
            	var rect = tabSection.getBoundingClientRect()
            	if(rect.top < window.innerHeight / 3) {
					
					this.tabMenuItemHightlight(tabSection.id)
					return
				}
			})
		})
  	},

	tabMenuItemHightlight: function(tabId) {
		this.data.tabsMenu.forEach((tabMenuItem) => {
			if(tabMenuItem.getAttribute('href') == '#' + tabId) {
				tabMenuItem.classList.add('tabs__link--selected')
			}
			else {
				tabMenuItem.classList.remove('tabs__link--selected')
			}
		})
	}
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme-top-bar"]) return;
  try {
    


var TopBar = {
	data: {},

	init: function() {
		this.data.topBarEl = document.querySelector('.top-bar')
		if(!this.data.topBarEl) return
		this.data.closeEl = document.querySelector('.top-bar__close')
		this.data.topBarText = document.querySelector('.top-bar p').innerHTML
		this.data.cookiesName = 'Pwnage_topBar_' + this.stringToHash(this.data.topBarText)
		this.data.mainEl = document.querySelector('main')
		this.data.tabsEl = document.querySelector('.tabs')
        this.data.sbCustomizer = document.querySelector('.customizer_content__3d')
		this.data.contentEl = document.querySelector('.top-bar p')
		if (!this.getCookie(this.data.cookiesName) || Shopify.designMode) {
			if (this.data.topBarEl) {
			  	this.showBar()
			 	if(this.data.contentEl.innerHTML.indexOf('#countdown') > -1) {
					this.startTimer()
				}
			}
		}
		

		this.bindUIActions()
	},

	bindUIActions: function() {
		if (this.data.closeEl) {
			if(!Shopify.designMode) {
				this.data.closeEl.addEventListener('click', (event) => {
				  event.preventDefault()
				  this.hideBar()
				})
			}
		} 
	},

	startTimer: function() {
		var endDateString = this.data.contentEl.innerHTML.split("#countdown-")[1]
		endDateString = endDateString.split(' ')[0]
		var htmlToReplace = this.data.contentEl.innerHTML.replace("#countdown-" + endDateString, `<span class="timer__container tiny-margin-left tiny-margin-right border-radius">
			<strong id="timer__time" class="fg-color">-- : -- : --</strong>
		</span>`)
		this.data.contentEl.innerHTML = htmlToReplace

		var endTime = new Date(endDateString)

		this.data.countdownTimerEl = document.getElementById('timer__time')
		var countdownTimerEl = this.data.countdownTimerEl

		var now = new Date(Date.now())
		var diff = new Date(endTime.getTime() - now.getTime())
		if(diff.valueOf() > 0) countdownTimerEl.innerHTML = `${parseInt(diff.valueOf()/1000/60/60, 10)} : ${diff.getUTCMinutes()} : ${diff.getUTCSeconds()}`
		else countdownTimerEl.innerHTML = "Offer Expired"
		
		setInterval(function() {
			var now = new Date(Date.now())
			var diff =  new Date(endTime.getTime() - now.getTime())
			if(diff.valueOf() > 0) countdownTimerEl.innerHTML = `${parseInt(diff.valueOf()/1000/60/60, 10)} : ${diff.getUTCMinutes()} : ${diff.getUTCSeconds()}`
			else countdownTimerEl.innerHTML = "Offer Expired"
		}, 1000)
	},

	showBar: function() {
		document.body.classList.add('has-top-bar')
		this.data.topBarEl.classList.remove('hide')
		this.data.mainEl.style.marginTop = this.data.topBarEl.offsetHeight + "px"
        if(this.data.sbCustomizer) {
            this.data.sbCustomizer.style.top = this.data.topBarEl.offsetHeight + "px"
        }
		if(this.data.tabsEl) {
			this.data.tabsEl.dataset.top = parseInt(window.getComputedStyle(this.data.tabsEl).top, 10)
			this.data.tabsEl.style.top = (parseInt(this.data.tabsEl.dataset.top, 10) + parseInt(this.data.topBarEl.offsetHeight, 10)) + 'px'
		}
	},

	hideBar: function() {
		document.body.classList.remove('has-top-bar')
		this.setCookie(this.data.cookiesName, true, 365)
		this.data.topBarEl.classList.add('hide')
		this.data.mainEl.style.marginTop = 0
        if(this.data.sbCustomizer) {
            this.data.sbCustomizer.style.top = 0
        }
		if(this.data.tabsEl) {
			this.data.tabsEl.style.top = this.data.tabsEl.dataset.top + 'px'
		}
	},

	setCookie: function(name, value, days) {
	  var expires = "";
	  if (days) {
	      var date = new Date();
	      date.setTime(date.getTime() + (days*24*60*60*1000));
	      expires = "; expires=" + date.toUTCString();
	  }
	  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	},

	getCookie: function(name) {
	  var nameEQ = name + "=";
	  var ca = document.cookie.split(';');
	  for(var i = 0; i < ca.length; i++) {
	      var c = ca[i]
	      while (c.charAt(0)==' ') c = c.substring(1,c.length)
	      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length)
	  }
	  return null;
	},

	stringToHash: function(string) {
    var hash = 0
    if (string.length == 0) return hash
    for (i = 0; i < string.length; i++) {
        char = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }
    return hash
  }
}
 
document.addEventListener("shopify:section:load", function(event) {
  if(event.detail.sectionId === "theme-top-bar") {
		TopBar.init()
  }
})
TopBar.init()


  } catch(e) { console.error(e); }
})();
})();
